export default __webpack_public_path__ + "static/media/header.48f69156.jpg";